import { gql } from '@apollo/client';

import { BodyColorFacetFragment } from './bodyColor';
import { DriveFacetFragment } from './drive';
import { EquipmentFacetFragment } from './equipment';
import { FuelTypeFacetFragment } from './fuelType';
import { InteriorFacetFragment } from './interior';
import { MakeFacetFragment } from './make';
import { PriceFacetFragment } from './price';
import { VehicleConditionsFacetFragment } from './vehicleConditions';
import { VehicleTypeFacetFragment } from './vehicleType';

export const FragmentFacetsAll = gql`
  fragment FragmentFacetsAll on Query {
    facets(origin: $origin) {
      ...BodyColorFacetFragment
      ...DriveFacetFragment
      ...EquipmentFacetFragment
      ...FuelTypeFacetFragment
      ...InteriorFacetFragment
      ...MakeFacetFragment
      ...PriceFacetFragment
      ...VehicleConditionsFacetFragment
      ...VehicleTypeFacetFragment
      merchantUuids {
        name
        displayName
      }
    }
  }
  ${BodyColorFacetFragment}
  ${DriveFacetFragment}
  ${EquipmentFacetFragment}
  ${FuelTypeFacetFragment}
  ${InteriorFacetFragment}
  ${MakeFacetFragment}
  ${PriceFacetFragment}
  ${VehicleConditionsFacetFragment}
  ${VehicleTypeFacetFragment}
`;
